import React from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import CamposBuque from './CamposBuque'
import { FORM_BUQUES } from '../../../config/forms'

function AgregarBuqueDialogView () {
  return (
    <>
      <CamposBuque newBuque />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    consultaBuque: state.buque.consultaBuque
  }
}

const withRedux = connect(mapStateToProps, null)

const withReduxForm = reduxForm({
  form: FORM_BUQUES,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(AgregarBuqueDialogView))
